import L from 'leaflet';
import serializeStyle from '../serializeStyle';
import './index.css';

const OPTIONS = {
  latLng: [51.505, -0.104],
  imageUrl: '//zzcpoi.b0.upaiyun.com/city_pic/8189.jpg!/both/120x120/format/jpg/quality/85/strip/true/compress/true',
  title: '城市名称',
  desc: '第几天游玩？',
  size: {
    // height: '0.6rem',
    // width: '1.8rem'
  }
};

export default function imageTextMarker(options = {}, markerOptions = {}) {
  options = {...OPTIONS, ...options};

  let style = serializeStyle({
    'background-image': `url(${options.imageUrl})`
  });

  let icon = L.divIcon({
    iconSize: [90, 29],
    className: 'component-map-image-text-marker',
    html: `<div>
            <div class='pic' style="${style}"></div>
            <div class='text'>
              <h4>${options.title}</h4>
              <p>${options.desc}</p>
            </div>
          </div>`
  });

  markerOptions.icon = icon;

  let marker = L.marker(options.latLng, markerOptions);

  marker.markerOptions = options;

  return marker;
}



// WEBPACK FOOTER //
// ./src/components/Map/imageTextMarker/index.js